import { Image, Menu } from "antd";
import { Component } from "react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import exclamationIcon from "../assets/images/NewDesign/exclamation-triangle-fill.svg";

class GatewayMenu extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      items: [],
      remaining: [],
    };
  }

  handleMenuClick = (items) => {
    this.props.navigate("/" + items);
    this.props.closeMenu();
  };

  async componentDidMount() {
    const items = [
      {
        key: "info",
        type: "group",
        label: (
          <div
            style={{
              padding: "15px",
              color: "#fff",
              backgroundColor: "#002766",
            }}
          >
            <span className="menu-items-title" style={{ gap: 10 }}>
              <img
                src={require("../assets/images/NewDesign/gatewayfill.png")}
                alt="Masters"
                style={{ width: "25px", filter: "brightness(0) invert(1)" }}
              />
              {this.context.translate("_GATEWAY_")}
            </span>

            <p
              style={{
                fontSize: "10px",
                marginTop: "5px",
                color: "rgba(255, 255, 255, 0.8)",

                marginBottom: "0px",
              }}
            >
              {this.context.translate("_GATEWAY_DESC_")}
            </p>
          </div>
        ),
      },
    ];

    const remaining2 = [
      {
        key: "sensorreportlist",
        type: "sensorreportlist",
        label: (
          <div onClick={() => this.handleMenuClick("sensorreportlist")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/Tracking/broadcast.png")}
                // alt="Masters"
                style={{ width: "16px" }}
              />
              {this.context.translate("_SENSOR_REPORT_")}
            </span>

            <p className="submenu-items-desc">
              {this.context.translate("_SENSOR_REPORT_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "gatewayDashboard",
        type: "gatewayDashboard",
        label: (
          <div onClick={() => this.handleMenuClick("gatewayDashboard")}>
            <span
              className="submenu-items-title"
              style={{
                gap: 10,
              }}
            >
              <Image
                src={require("../assets/images/NewDesign/gatewayDashboard.png")}
                // alt="Masters"
                style={{ width: "20px" }}
              />
              {this.context.translate("_GATEWAY_DASHBOARD_")}
            </span>

            <p className="submenu-items-desc">
              {this.context.translate("_GATEWAY_DASHBOARD_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
    ];

    var remaining = [];
    for (var i = 0; i < remaining2.length; i++) {
      const item = remaining2[i];
      if (!item || !item.key) continue;
      console.log(remaining2[i].key);
      if (this.props.gatewayManagement.includes(remaining2[i].key)) {
        remaining.push(remaining2[i]);
      }
    }

    this.setState({ items: items, remaining: remaining });
  }

  render() {
    return (
      <div className="menu-items-card">
        <div className="menu-items-list">
          <Menu
            style={{
              border: "none",
              scrollbarWidth: "none",
              overflow: "scroll",
            }}
            items={this.state.items}
          />
        </div>
        <div className="submenu-items-list">
          <Menu
            className="gateway-list-menu"
            style={{
              height: "90vh",
              border: "none",
              scrollbarWidth: "none",
              overflow: "scroll",
              boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
              // display: "flex",
              // flexWrap: "wrap",
              // justifyContent: "center",
              // alignContent: "flex-start",
              height: "100%",
            }}
            mode="inline"
            items={this.state.remaining}
            onMouseLeave={() => this.props.closeMenu()}
          />
        </div>
      </div>
    );
  }
}
GatewayMenu.contextType = StoreContext;
export default observer(withRouter(GatewayMenu));
